import React from 'react';

import './Hotspot.scss'

const Hotspot = ({
  coordinates: [top, left, width, height],
  onClick,
  index
}) => {
  let className = 'Hotspot';
  let Hotspot_yn = 0;

  return (
    <div className={className} onClick={onClick} style={{
      top: `${top}%`,
      left: `${left}%`,
      width: `${width}%`,
      height: `${height}%`
    }}>
      <div className="index">
        <div className="number">{index + 1}</div>
      </div>
      {Hotspot_yn == 0 ? <div className=""></div> : Hotspot_yn == 1 ? <div className="pos_tick"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
        <g id="icn-Correct" transform="translate(-119 -317)">
          <g id="Ellipse_242" data-name="Ellipse 242" transform="translate(119 317)" fill="#63c132" stroke="#eee5e9" stroke-width="2">
            <circle cx="15" cy="15" r="15" stroke="none" />
            <circle cx="15" cy="15" r="14" fill="none" />
          </g>
          <path id="Icon_awesome-check" data-name="Icon awesome-check" d="M7.083,19.823.305,13.045a1.043,1.043,0,0,1,0-1.475L1.78,10.1a1.043,1.043,0,0,1,1.475,0L7.82,14.662,17.6,4.883a1.043,1.043,0,0,1,1.475,0l1.475,1.475a1.043,1.043,0,0,1,0,1.475L8.558,19.823A1.043,1.043,0,0,1,7.083,19.823Z" transform="translate(123.573 320.647)" fill="#eee5e9" />
        </g>
      </svg></div> : <div className="pos_wrong"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
        <g id="icn-Incorrect" transform="translate(-119 -317)">
          <g id="Ellipse_242" data-name="Ellipse 242" transform="translate(119 317)" fill="#a31621" stroke="#eee5e9" stroke-width="2">
            <circle cx="15" cy="15" r="15" stroke="none" />
            <circle cx="15" cy="15" r="14" fill="none" />
          </g>
          <path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M21.744,19.742l6.04-6.04a1.415,1.415,0,0,0-2-2l-6.04,6.04L13.7,11.7a1.415,1.415,0,1,0-2,2l6.04,6.04-6.04,6.04a1.415,1.415,0,0,0,2,2l6.04-6.04,6.04,6.04a1.415,1.415,0,0,0,2-2Z" transform="translate(114.259 312.258)" fill="#eee5e9" />
        </g>
      </svg></div>}
    </div>
  );
};

export default Hotspot;
